/**
 * Schema of MotoristaCancelamentoCarga
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {datetime} from 'simpli-web-sdk'
import MotoristaCancelamentoCarga from '@/model/resource/MotoristaCancelamentoCarga'

export default (model: MotoristaCancelamentoCarga): Schema => ({
  cargaNroNotaFiscal: {
    content: model.carga && model.carga.nroNotaFiscal || '',
    input: InputType.SELECT,
  },

  motorista: {
    content: model.motorista && model.motorista.$tag || '',
    input: InputType.SELECT,
  },

  idCancelamentoPk: {
    content: model.idCancelamentoPk,
    hidden: true,
    editable: false,
  },

  data: {
    content: datetime(model.data),
    input: InputType.DATETIME,
    meta: {
      required: true,
    },
  },
})
